import BaseComponent from "../../BaseComponent";

export default class TopicForm extends BaseComponent {

	private $rewardTypeRadios: JQuery<HTMLInputElement>;
	private $topicRewardSetupCheckbox: JQuery<HTMLInputElement>;
	private $topicRewardInput: JQuery<HTMLInputElement>;
	private rewardSetupEnabledOrigin: boolean;
	private rewardValueOrigin: string;


	public init(): void {
		this.$rewardTypeRadios = this.$component.find('input[name="reward_after_topic_or_post"]');
		this.$topicRewardSetupCheckbox = this.$component.find('input[name="enable_topic_reward_setup"]');
		this.$topicRewardInput = this.$component.find('input[name="topic_reward"]');
		this.rewardSetupEnabledOrigin = this.$topicRewardSetupCheckbox.prop('checked');
		this.rewardValueOrigin = this.$topicRewardInput.val();

		this.setupRadios();
		this.setupCheckbox();

		this.$rewardTypeRadios.on('change', () => this.setupRadios());
		this.$topicRewardSetupCheckbox.on('change', () => this.setupCheckbox());

		this.$component.closest('.modal').on('shown.bs.modal', () => {
			this.$component.find('input[name="name"]').trigger('focus');
		});

		this.$component.find('input[name="cancel"]').on('click', () => {
			this.$topicRewardInput.val(this.rewardValueOrigin).trigger('change');
			this.$topicRewardSetupCheckbox.prop('checked', this.rewardSetupEnabledOrigin).trigger('change');
		});
	}

	private setupRadios(): void {
		const checkedInput = this.$rewardTypeRadios.filter(':checked')[0];
		const topicRewardEnabled = checkedInput && checkedInput.value === 'topic';
		this.$topicRewardSetupCheckbox.prop('disabled', !topicRewardEnabled);
		if (!topicRewardEnabled) {
			this.$topicRewardSetupCheckbox.prop('checked', false).trigger('change');
		}
	}

	private setupCheckbox(): void {
		const rewardSetupEnabled = this.$topicRewardSetupCheckbox.prop('checked') === true;
		this.$topicRewardInput.prop('disabled', !rewardSetupEnabled);
		if (!rewardSetupEnabled) {
			this.$topicRewardInput.hide(100).val('').trigger('change');
		} else {
			this.$topicRewardInput.show(100);
		}
	}
}